// Owner correction: every Basic lower base meets the floor. Keep each mattress configuration distinct.
export const BASIC_MODEL_PHOTOS = [
  {
    "url": "/media/basic-models/twin-twin-floor-flush.webp",
    "alt": "Twin over Twin",
    "legacyUrl": "https://hvsfchqfzpnklwfmxajh.supabase.co/storage/v1/object/public/bliss-basic-gallery/f259b94e-7ec3-47a6-9031-ad6ee3608705/supplier-catalog/b571e655-224b-4498-91fa-9da5959d28c7.jpg"
  },
  {
    "url": "/media/basic-models/twinxl-twinxl-floor-flush.webp",
    "alt": "Twin XL over Twin XL",
    "legacyUrl": "https://hvsfchqfzpnklwfmxajh.supabase.co/storage/v1/object/public/bliss-basic-gallery/f259b94e-7ec3-47a6-9031-ad6ee3608705/supplier-catalog/705fe9ec-0aa9-4e1e-89bc-f4899bae4ac5.jpg"
  },
  {
    "url": "/media/basic-models/twin-full-floor-flush.webp",
    "alt": "Twin over Full",
    "legacyUrl": "https://hvsfchqfzpnklwfmxajh.supabase.co/storage/v1/object/public/bliss-basic-gallery/f259b94e-7ec3-47a6-9031-ad6ee3608705/supplier-catalog/b5f28ff8-fd7f-4d9c-ab5a-931a0e6ec2b0.jpg"
  },
  {
    "url": "/media/basic-models/twinxl-queen-floor-flush.webp",
    "alt": "Twin XL over Queen",
    "legacyUrl": "https://hvsfchqfzpnklwfmxajh.supabase.co/storage/v1/object/public/bliss-basic-gallery/f259b94e-7ec3-47a6-9031-ad6ee3608705/supplier-catalog/f3fb9a95-15e0-4d4d-99a4-c53ece7daa1b.jpg"
  },
  {
    "url": "/media/basic-models/queen-queen-floor-flush.webp",
    "alt": "Queen over Queen",
    "legacyUrl": "https://hvsfchqfzpnklwfmxajh.supabase.co/storage/v1/object/public/bliss-basic-gallery/f259b94e-7ec3-47a6-9031-ad6ee3608705/supplier-catalog/f4234a79-c403-4bfe-91f9-db1598f15bb9.jpg"
  },
  {
    "url": "/media/basic-models/full-full-floor-flush.webp",
    "alt": "Full over Full",
    "legacyUrl": "https://hvsfchqfzpnklwfmxajh.supabase.co/storage/v1/object/public/bliss-basic-gallery/f259b94e-7ec3-47a6-9031-ad6ee3608705/supplier-catalog/a8d52880-6ad9-40f6-9e13-ea6bdd539b14.jpg"
  }
] as const;

/** Replace only superseded catalog artwork; preserve newly published owner photos. */
export function basicModelPhotoUrl(url:string):string {
 return BASIC_MODEL_PHOTOS.find(photo=>photo.legacyUrl===url)?.url??url;
}

